<template>
  <div
    class="bulk-item"
    :class="{ empty: info.from === 'delete', focus: focus }"
  >
    <div class="main-container">
      <div class="top-container">
        <media-crop-thumbnails
          v-if="!loading && hasMedia"
          class="image"
          :cover="true"
          :model="info.images[0]"
        >
          <div style="z-index: 3">
            <!-- <div class="add-icon"
                 @click="showForm('showMediaModal')"></div> -->
            <div
              class="edit-icon"
              @click="showForm('showMediaCropModal')"
            ></div>
            <div class="mul-icon" v-show="info.images.length > 1"></div>
          </div>
        </media-crop-thumbnails>
        <div v-if="loading" class="image">
          <div v-show="loading" class="image-mask-container">
            <img
              src="../../../../../public/images/common/default-placeholder.png"
              class="mask-img"
            />
          </div>
        </div>
        <hi-text-area
          v-if="twitter"
          type="bulk"
          ref="caption"
          socialNetwork="twitter"
          class="caption-container"
          :max="280"
          v-model="info.form.caption"
          placeholder="write a twetter..."
          :rows="3"
        ></hi-text-area>
        <hi-text-area
          v-else
          type="bulk"
          ref="caption"
          class="caption-container"
          :max="30"
          :filterNum="filterNum"
          v-model="info.form.caption"
          placeholder="write a caption..."
          filterText="#"
          :rows="3"
        ></hi-text-area>
      </div>
      <div class="bottom-container">
        <div class="icon-container" v-if="showComment">
          <div
            class="icon tag-people"
            @click="showForm('showTagPeopleModal')"
            v-if="instagram"
            :class="{ empty: !hasTagPeople }"
          ></div>
          <bulk-location
            :form="info.form"
            v-if="instagram"
            :empty="!hasLocation"
            @clear="locationClear"
            @itemClick="saveLocation"
          ></bulk-location>
          <div
            class="icon comment"
            @click="showForm('showCommentModal')"
            v-if="!facebookGroup"
            :class="{ empty: !hasFirstComment }"
          ></div>
          <!-- <div class="icon product"
               v-if="instagram"
               @click="showForm('showTagProductModal')"
               :class="{empty:!hasProductTag}"></div> -->
          <div class="spilt-line"></div>
        </div>
        <div
          class="caption-type"
          :class="{ 'hide-comment': !showComment }"
          ref="typeContainer"
        >
          <div
            :class="{ selected: type.selected }"
            class="type"
            :key="type.id"
            v-for="type in captionTypes"
            @click="switchCaption(type.id)"
          >
            {{ type.text }}
          </div>
        </div>
        <div class="user-container">
          <div class="user-item" v-for="p in publisherList" :key="p.username">
            <div class="image" v-lazy:background-image="p.image" :key="p.image">
              <div v-if="p.socialNetwork === 1" class="ins-user-icon"></div>
              <div v-if="p.socialNetwork === 2" class="fb-page-user-icon"></div>
              <div
                v-if="p.socialNetwork === 3"
                class="fb-group-user-icon"
              ></div>
              <div v-if="p.socialNetwork === 4" class="tw-user-icon"></div>
            </div>
          </div>
          <ins-list
            :disabled="!multiPublisherDistribution"
            placement="right"
            type="mul"
            filter="login"
            :selectIds="info.form.publisherIds"
          >
            <div @click="multiPublisherClick" class="add-user-btn"></div>
          </ins-list>
        </div>
      </div>
      <div
        class="caption-list-container"
        ref="captionContainer"
        v-if="currentCaption"
      >
        <div class="title">{{ currentCaption.text }}</div>
        <template v-if="!empty">
          <suggested
            type="bulk"
            @itemClick="captionItemClick"
            v-show="currentCaption.id === 3"
          ></suggested>
          <div class="scroller-view" v-show="currentCaption.id !== 3">
            <caption-item
              :model="caption"
              type="bulk"
              v-show="currentCaption.id !== 3"
              :key="caption.id"
              @click="captionItemClick"
              v-for="caption in captionList"
            ></caption-item>
          </div>
        </template>
        <div v-if="empty" class="no-list">
          {{ empty }}
        </div>
      </div>
    </div>
    <div class="operation-container">
      <div class="del-icon" @click="del"></div>
      <div class="move-icon"></div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
@import "../../../../assets/style/theme";

.media-crop-hide {
  top: calc(~"-100vh - 500px");
  opacity: 0;
}

.bulk-item {
  display: flex;
  width: 470px;

  &.focus.empty {
    background: #f5cfd8 !important;
  }

  &.empty {
    .main-container,
    .operation-container {
      display: none;
    }

    background: #f5f5f5 !important;
    border-radius: 4px;
    border: dashed 1px #d2d2d2;
  }

  .main-container {
    border: solid 1px #e6e6e6;
    flex: 1;
    background: white;
    border-radius: 6px;

    .top-container {
      height: 75px;
      border-bottom: solid 1px #e6e6e6;
      display: flex;
      padding: 8px 8px 0 8px;

      .image {
        width: 60px;
        height: 60px;
        position: relative;
        margin-right: 12px;
        .image-mask-container {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background: #e9eef1;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;

          .mask-img {
            width: 50%;
            max-width: 60px;
            display: block;
          }
        }
        .edit-icon {
          width: 20px;
          height: 20px;
          background-size: contain;
          position: absolute;
          cursor: pointer;
          left: 0;
          top: 0;
          background-image: url(../../../../../public/images/bulk/Edit@3x.png);
        }

        .mul-icon {
          width: 15px;
          height: 15px;
          background-size: contain;
          position: absolute;
          right: 3px;
          top: 3px;
          background-image: url(../../../../../public/images/library/album@3x.png);
        }

        .add-icon {
          width: 20px;
          height: 20px;
          cursor: pointer;
          background-size: contain;
          position: absolute;
          right: 0;
          bottom: 0;
          background-image: url(../../../../../public/images/bulk/img_add@3x.png);
        }
      }

      .caption-container {
        height: 60px;
        flex: 1;
      }
    }

    .bottom-container {
      height: 32px;
      display: flex;
      align-items: center;
      padding: 0 8px;

      .icon-container {
        display: flex;
        align-items: center;
        height: 14px;
        border-right: 1px solid #d2d2d2;

        .icon {
          height: 24px;
          width: 24px;
          background-size: 16px;
          margin-right: 2px;
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer;

          &.tag-people {
            background-image: url("../../../../../public/images/bulk/storylist_tag_b red@3x.png");
          }

          &.comment {
            background-image: url("../../../../../public/images/bulk/storylist_com_b red@3x.png");
          }

          &.product {
            background-image: url("../../../../../public/images/bulk/storylist_product_b red@3x.png");
          }

          &.empty {
            &:hover,
            &:active {
              &.tag-people {
                background-image: url("../../../../../public/images/bulk/storylist_tag_b red@3x.png");
              }

              &.comment {
                background-image: url("../../../../../public/images/bulk/storylist_com_b red@3x.png");
              }

              &.product {
                background-image: url("../../../../../public/images/bulk/storylist_product_b red@3x.png");
              }
            }

            &.tag-people {
              background-image: url("../../../../../public/images/bulk/storylist_tag_b@3x.png");
            }

            &.comment {
              background-image: url("../../../../../public/images/bulk/storylist_com_b@3x.png");
            }

            &.product {
              background-image: url("../../../../../public/images/bulk/storylist_product_b@3x.png");
            }
          }
        }
      }

      .caption-type {
        font-size: 14px;
        color: rgb(140, 140, 140);
        padding: 0 6px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 14px;
        border-right: 1px solid #d2d2d2;
        &.hide-comment {
          margin-left: -12px;
        }
        .type {
          cursor: pointer;
          margin: 0 6px;
          &:hover,
          &:active {
            color: @theme-color;
          }

          &.selected {
            color: black;
          }
        }
      }

      .user-container {
        margin-left: 8px;
        flex: 1;
        align-items: center;
        overflow-x: auto;
        display: flex;

        .add-user-btn {
          width: 18px;
          height: 18px;
          background-size: contain;
          background-image: url("../../../../../public/images/bulk/add@3x.png");
          cursor: pointer;

          &:hover,
          &:active {
            background-image: url("../../../../../public/images/bulk/add_red@3x.png");
          }
        }

        .user-item {
          display: flex;
          align-items: center;
          margin-right: 4px;

          .image {
            height: 20px;
            width: 20px;
            border-radius: 50%;
            background-size: contain;
            background-position: center;
            position: relative;
            .ins-user-icon,
            .fb-page-user-icon,
            .fb-group-user-icon {
              width: 11px;
              height: 11px;
            }
          }

          .username {
            margin: 0 7px;
            font-size: 14px;
          }
        }
      }
    }

    .caption-list-container {
      height: 483px;
      border-top: solid 1px #e6e6e6;
      background: white;
      padding: 10px 15px;
      display: flex;
      flex-direction: column;
      width: 448px;
      border-radius: 0 0 8px 8px;

      .no-list {
        display: flex;
        font-size: 16px;
        color: gray;
        flex: 1;
        align-items: center;
        justify-content: center;
      }

      .title {
        font-size: 14px;
        font-weight: 500;
      }

      .scroller-view {
        flex: 1;
        overflow: auto;
      }
    }
  }

  .operation-container {
    width: 20px;
    display: flex;
    flex-direction: column;
    padding-top: 27px;
    align-items: center;

    .move-icon {
      width: 20px;
      height: 20px;
      background-size: contain;
      background-image: url("../../../../../public/images/bulk/Move@3x.png");
      cursor: move;
      margin-top: 27px;

      &:hover,
      &:active {
        opacity: 0.7;
      }
    }

    .del-icon {
      background-image: url("../../../../../public/images/bulk/Delete@3x.png");
      width: 20px;
      height: 20px;
      cursor: pointer;
      background-size: contain;

      &:hover,
      &:active {
        opacity: 0.7;
      }
    }
  }
}
</style>

<script>
import hiTextArea from "../../../common/form/TextArea.vue";
import insList from "../../../plan_header/ins_list/Index";
import groups from "../../../../const/suggest_hashtag";
import suggested from "../../../media/schedule/suggested/Suggested";
import CaptionItem from "../../../calender/caption/Index.vue";
import BulkLocation from "./BulkLocation";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE,
} from "../../../../store/mutation-types";
import { mapGetters } from "vuex";
import MediaCropThumbnails from "../../crop/Thumbnail";
import { permissionValidate } from "../../../../service/publisher";
import { sleep } from "../../../../utils";
import { showErrorMsg } from "../../../../utils/errors";
import { setCropImages } from "../../../../service/media";

export default {
  name: "BulkItemComponent",
  components: {
    MediaCropThumbnails,
    BulkLocation,
    CaptionItem,
    hiTextArea,
    insList,
    suggested,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    focus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historyList: [],
      loading: false,
      savedList: [],
      suggestedList: groups,
      images: this.info.images,
      showCrop: false,
      ready: null,
      captionTypes: [
        { id: 1, text: "History", selected: false },
        { id: 2, text: "Saved", selected: false },
        { id: 3, text: "Suggested#", selected: false },
      ],
    };
  },
  methods: {
    del() {
      this.closeCaption();
      this.$emit("del");
    },
    locationClear() {
      this.info.form.location = null;
    },
    /**
     * 多选publisher按钮点击事件
     */
    async multiPublisherClick() {
      // 判断如果已经存在一个tag product则不能添加
      if (this.tagProducts.length > 0) {
        await this.$alert.show({
          text: "Tag Product is not available when you apply to multiple Instagram.",
          yesText: "OK",
        });
        return;
      }
      // 如果没有权限则弹出对应升级提示
      if (!this.multiPublisherDistribution) {
        await permissionValidate({ type: "basic" });
      }
    },
    /**
     * 显示form表单
     */
    async showForm(type) {
      // 发现如果是视频则编辑多媒体无法进行
      if (
        this.hasVideo &&
        (type === "showMediaModal" || type === "showMediaEditModal")
      ) {
        this.$bus.$emit("showDownload");
        return;
      }
      this.info.only = type;
      if (type === "showTagProductModal") {
        if (!this.InsTagProductPermission) {
          try {
            await this.$confirm.show({
              text: "Your Instagram does not support this feature.",
              yesText: "OK",
              cancelText: "Help",
              showClose: false,
            });
          } catch (e) {
            if (e === "cancel") {
              window.open(process.env.VUE_APP_CONTACT_US, "_blank");
            }
          }
          return;
        }
        // 多账号不能tag people
        if (this.info.form.publisherIds.length > 1) {
          await this.$alert.show({
            text: "Tag Product is not available when you apply to multiple Instagram.",
            yesText: "OK",
          });
          return;
        }
        // tag product 和 tag people 互斥，2个功能不能同时使用
        if (this.userTags.length > 0) {
          await this.$alert.show({
            text: `Tagging people and products in the same post isn't available.`,
            yesText: `OK`,
          });
          return;
        }
        this.$bus.$emit("showScheduleForm", this.info);
      } else if (type === "showTagPeopleModal") {
        // tag product 和 tag people 互斥，2个功能不能同时使用
        if (this.tagProducts.length > 0) {
          await this.$alert.show({
            text: `Tagging people and products in the same post isn't available.`,
            yesText: `OK`,
          });
          return;
        }
        this.$bus.$emit("showScheduleForm", this.info);
      } else {
        this.$bus.$emit("showScheduleForm", this.info);
      }
    },
    /**
     * 保存location信息
     */
    saveLocation(location) {
      this.info.form.location = location;
    },
    /**
     * 切换caption类型
     */
    switchCaption(type) {
      const switchItem = this.captionTypes.find((c) => c.id === type);
      if (switchItem.selected) {
        switchItem.selected = false;
      } else {
        this.captionTypes.forEach((c) => {
          c.selected = false;
        });
        switchItem.selected = true;
      }
    },
    /**
     * 关闭caption
     */
    closeCaption() {
      this.captionTypes.forEach((c) => {
        c.selected = false;
      });
    },
    /**
     * caption项点击事件
     */
    captionItemClick(item) {
      this.$refs.caption.addText(item.text);
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      publisher: CURRENT_PUBLISHER_SIMPLE,
      captionCommentList: CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE,
    }),
    hasMedia() {
      return this.$route.query.bulkType !== "text";
    },
    instagram() {
      return this.publisher.socialNetwork === 1;
    },
    facebookGroup() {
      return this.publisher.socialNetwork === 3;
    },
    twitter() {
      return this.publisher.socialNetwork === 4;
    },
    showComment() {
      return (
        this.publisher.socialNetwork === 1 ||
        this.publisher.socialNetwork === 2 ||
        this.twitter
      );
    },
    /**
     * post中是否含有視頻
     */
    hasVideo() {
      // 視頻 或者 story中是视频
      return this.images.findIndex((m) => m.type === 2) !== -1;
    },
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * 多账号发布权限
     */
    multiPublisherDistribution() {
      return this.permission.multi_publisher_distribution;
    },
    // 计算当前选中publisher的信息
    publisherList() {
      return this.info.form.publisherIds.map((p) => {
        return this.user.linkedInstagramList.find((l) => l.publisherId === p);
      });
    },
    /**
     * 当前切换需要展示的caption
     */
    captionList() {
      if (!this.captionCommentList) {
        return [];
      }
      const captionList = this.captionCommentList.caption.map((c) => {
        return {
          text: c.content,
          date: c.date_created,
          ...c,
        };
      });
      if (this.currentCaption.id === 1) {
        return captionList.filter((c) => c.is_history);
      } else if (this.currentCaption.id === 2) {
        return captionList.filter((c) => c.is_saved);
      }
      return [];
    },
    empty() {
      if (this.captionList.length === 0) {
        if (this.currentCaption.id === 1) {
          return "No history here";
        } else if (this.currentCaption.id === 2) {
          return "No saved here";
        }
      }
      return "";
    },
    /**
     * 当前caption
     */
    currentCaption() {
      return this.captionTypes.find((c) => c.selected);
    },
    /**
     * 计算#出现次数
     * @returns {number}
     */
    filterNum() {
      const caption = this.info.form.caption || "";
      const firstComment = this.info.form.firstComment || "";
      const text = caption + firstComment;
      const find = [...text].filter((v) => {
        return v === "#";
      });
      return find.length;
    },
    /**
     * 计算user tag
     */
    userTags() {
      let tags = [];
      this.info.images.forEach((img) => {
        img.usertags.forEach((tag) => {
          // 查看是否存在重复项
          const index = tags.findIndex((t) => t.user_id === tag.user_id);
          if (index === -1) {
            tags.push(tag);
          }
        });
      });
      return tags;
    },
    /**
     * 计算product tag
     */
    tagProducts() {
      let tags = [];
      this.info.images.forEach((img) => {
        img.product_tags.forEach((tag) => {
          // 查看是否存在重复项
          const index = tags.findIndex((t) => t.id === tag.id);
          if (index === -1) {
            tags.push(tag);
          }
        });
      });
      return tags;
    },
    hasTagPeople() {
      return this.userTags.length > 0;
    },
    hasLocation() {
      return !!this.info.form.location;
    },
    hasFirstComment() {
      return !!this.info.form.firstComment;
    },
    hasProductTag() {
      return this.tagProducts.length > 0;
    },
    /**
     * 是否ins给予tag product权限
     */
    InsTagProductPermission() {
      return this.publisher.socialCanTagProducts;
    },
  },
  async mounted() {
    this.ready = new Promise(async (resolve) => {
      try {
        this.loading = true;
        // 点击其他区域消失
        window.document.addEventListener("mousedown", (e) => {
          if (!this.$refs.captionContainer || !this.$refs.typeContainer) {
            return;
          }
          // 刨去指定区域不隐藏
          if (
            this.$refs.captionContainer.contains(e.target) ||
            this.$refs.typeContainer.contains(e.target)
          ) {
            return;
          }
          sleep({ time: 100 }).then(() => {
            this.captionTypes.forEach((c) => {
              c.selected = false;
            });
          });
        });
        window.document.addEventListener("input", (e) => {
          if (!this.$refs.captionContainer || !this.$refs.typeContainer) {
            return;
          }
          if (
            this.$refs.captionContainer.contains(e.target) ||
            this.$refs.typeContainer.contains(e.target)
          ) {
            return;
          }
          sleep({ time: 100 }).then(() => {
            this.captionTypes.forEach((c) => {
              c.selected = false;
            });
          });
        });
        // 获取拖入bulk的全部图片信息，不包含视频
        await setCropImages({ images: this.info.images });
        resolve();
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.loading = false;
      }
    });
    // 如果是fb则不显示suggest
    if (this.publisher.socialNetwork !== 1) {
      this.captionTypes.splice(2, 1);
    }
  },
};
</script>
